import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_a7rynywhaw: FaireBrandEntity = {
  token: "b_a7rynywhaw",
  type: "brand",
  name: "RAISONNEL",
  avatarUrl:
    "https://cdn.faire.com/fastly/22fc7ee0d72b37d79b57ea4162d4311e2a23ca02441df5aeda2d252eb3bf2360.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/1a27c8f33fe40ae426b20da1575d20eafaa801e8db195f20d6e654a5748bd6c1.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/22fc7ee0d72b37d79b57ea4162d4311e2a23ca02441df5aeda2d252eb3bf2360.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/1a27c8f33fe40ae426b20da1575d20eafaa801e8db195f20d6e654a5748bd6c1.jpeg",
  location: "Los Angeles , CA, USA",
  minimumOrderDollars: 99,
  rating: 4.9,
  reviewCount: 106,
  isTopShop: true,
  isInsider: true,
  description:
    'Raisonnel is a fashion brand that embodies the essence of practicality and style, as suggested by its name, which translates to "reason" or "rationale" in French.  Renowned for minimalist designs that emphasize functionality and timeless elegance, the brand\'s collections showcase neutral colors and clean lines, appealing to those who favor understated sophistication.  Raisonnel is perfect for the modern individual who values both form and function in their wardrobe.',
  meta: {
    source: "api",
    importedAt: "2026-07-23T06:21:44.280Z",
    importedBy: "entity-db-cli",
  },
};
